<div class="d-flex header-container">
  <div class="d-flex flex-g1 justify-content-start align-items-center logo">
    <img [src]="logoImage"/>
  </div>
  <div class="d-flex flex-g1 justify-content-end align-items-center">
    <div class="date">{{previousDate| date:'MMM dd, yyyy'}} - {{currentDate | date:'MMM dd, yyyy'}}</div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer-header/pdf-viewer-header.component.html